import React from "react";
import { Instagram } from "lucide-react";
import { SERVICES } from "../lib/services";
import { smoothScrollHash } from "../lib/smoothScroll";

const INSTAGRAM_URL = "https://www.instagram.com/zozoventure/";

export default function Footer({ minimal = false }) {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-white text-black border-t border-black/15" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        {minimal ? (
          <div className="flex flex-col items-center text-center gap-8">
            <a href="#top" onClick={smoothScrollHash} className="flex items-center gap-2" data-testid="footer-logo">
              <span className="inline-block w-3 h-3 bg-[#EAB308]" />
              <span className="font-heading font-black text-xl tracking-tight text-[#EAB308]">
                ZOZO VENTURE
              </span>
            </a>
            <div>
              <p className="text-xs tracking-[0.22em] uppercase text-black/50">Contact</p>
              <a
                href="mailto:info@zozoventure.com"
                className="mt-2 inline-block text-sm text-black/75 hover:text-[#EAB308]"
                data-testid="footer-email"
              >
                info@zozoventure.com
              </a>
              <div className="mt-3">
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Message ZOZO Venture on Instagram"
                  className="inline-flex items-center gap-2 text-sm text-black/75 hover:text-[#EAB308]"
                  data-testid="footer-instagram-minimal"
                >
                  <Instagram size={16} />
                  <span>DM us on Instagram</span>
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <a href="#top" onClick={smoothScrollHash} className="flex items-center gap-2" data-testid="footer-logo">
                <span className="inline-block w-3 h-3 bg-[#EAB308]" />
                <span className="font-heading font-black text-xl tracking-tight text-[#EAB308]">
                  ZOZO VENTURE
                </span>
              </a>
              <p className="mt-5 text-black/70 max-w-md">
                Everything a New Founder needs — Startup Funding, Company
                Registration, Banking, Payments, Workspace, IT, Branding and
                Digital — delivered by one accountable team.
              </p>
              <a
                href="#lead-form"
                onClick={smoothScrollHash}
                data-testid="footer-cta"
                className="mt-6 inline-flex items-center gap-2 bg-[#EAB308] text-white px-5 py-3 font-semibold hover:bg-black hover:text-white transition-colors"
              >
                Start your Startup →
              </a>
            </div>

            <div className="md:col-span-4">
              <p className="text-xs tracking-[0.22em] uppercase text-black/50">Services</p>
              <ul className="mt-4 grid grid-cols-2 gap-y-2 gap-x-6">
                {SERVICES.map((s) => (
                  <li key={s.id}>
                    <a
                      href="#services"
                      onClick={smoothScrollHash}
                      data-testid={`footer-link-${s.id}`}
                      className="text-sm text-black/75 hover:text-[#EAB308] transition-colors"
                    >
                      {s.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-3">
              <p className="text-xs tracking-[0.22em] uppercase text-black/50">Contact</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li>
                  <a
                    href="mailto:info@zozoventure.com"
                    className="text-black/75 hover:text-[#EAB308]"
                    data-testid="footer-email"
                  >
                    info@zozoventure.com
                  </a>
                </li>
                <li>
                  <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Message ZOZO Venture on Instagram (opens in new tab)"
                    className="inline-flex items-center gap-2 text-black/75 hover:text-[#EAB308] transition-colors"
                    data-testid="footer-instagram"
                  >
                    <Instagram size={16} />
                    <span>DM us on Instagram</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )}

        <div className="mt-16 pt-8 border-t border-black/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-black/55">
            © {year} ZOZO Venture. All rights reserved.
          </p>
          <p className="text-xs text-black/55">Built for India&apos;s new founders.</p>
        </div>
      </div>
    </footer>
  );
}
